
  import { Component, Vue ,Prop,Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:false}) show!: boolean;
    private validationShow = false
    private IsShow = false
    private puzzleImgList = [
      'http://cdn2024.shiwuzone.com/routuan/image/396fff86271a44d220c044b798d2819.jpg',
      'http://cdn2024.shiwuzone.com/routuan/image/b9b3544d92802bfeeda6e007e86d2a3.jpg',
      'http://cdn2024.shiwuzone.com/routuan/image/31cc39ef0a4ee2ae442ce6685e0b587.jpg',
      'http://cdn2024.shiwuzone.com/routuan/image/749c421fa2fc1f132b024e68f2fa01c.jpg',
    ]
    @Watch('show') 
    private changeshow (val:boolean){
      // console.log(val)
      this.IsShow = val
    }

    private handleSuccess(){
      this.IsShow = false
      this.$emit('success')
    }
    private handleError(){
      // console.log(11,'shibai')
    }
    private close(){
      // console.log(1)
      this.IsShow = false
      this.$emit('close',false)
    }
  }
